export default {
    getAlerts: (state) => {
        return state.alerts
    },
}
